import { useEffect, useState } from "react";

export const AmyEasterEgg = () => {
  const [show, setShow] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isEnabled, setIsEnabled] = useState(() => {
    return localStorage.getItem("easter_egg_enabled") !== "disabled";
  });

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setShow(false);
      setIsClosing(false);
    }, 500); // Match animation duration
  };

  // Listen for toggle changes from settings
  useEffect(() => {
    const handleToggle = (e: CustomEvent<string>) => {
      setIsEnabled(e.detail === "enabled");
    };

    window.addEventListener("easter-egg-toggle", handleToggle as EventListener);
    return () => {
      window.removeEventListener("easter-egg-toggle", handleToggle as EventListener);
    };
  }, []);

  useEffect(() => {
    let buffer = "";
    const timeout = 500;
    let timer: ReturnType<typeof setTimeout>;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && show && !isClosing) {
        handleClose();
        return;
      }

      if (!isEnabled) return;
      if (!e.key) return;

      clearTimeout(timer);
      buffer += e.key.toLowerCase();

      if (buffer.includes("amy")) {
        setShow(true);
        buffer = "";
      }

      timer = setTimeout(() => {
        buffer = "";
      }, timeout);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      clearTimeout(timer);
    };
  }, [show, isClosing, isEnabled]);

  if (!show) return null;

  return (
    <div
      className={`fixed inset-0 z-9999 bg-black/30 backdrop-blur-xs transition-all flex items-end ${isClosing ? "animate-out fade-out" : "animate-in fade-in"
        } duration-500`}
      onClick={handleClose}
    >
      <div
        className={`fixed bottom-0 left-62 -translate-x-1/2 size-82 bg-transparent flex items-center justify-center ${isClosing ? "animate-out slide-out-to-bottom" : "animate-in slide-in-from-bottom"
          } duration-500`}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src="/amy.svg"
          className="size-82 object-cover shrink-0 bg-transparent"
          alt="Amy"
        />
        <span className="text-nowrap text-xs mb-auto font-medium text-foreground/90">
          Did you just type my name? 👀
        </span>
      </div>
    </div>
  );
};